import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { RejectPriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/priceSurvey/reject.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseReviewPriceSurveyProps {
  priceSurveyId?: string
  review: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useReviewPriceSurvey = ({ priceSurveyId, review, onSuccess, onError }: UseReviewPriceSurveyProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewPriceSurvey'],
    mutationFn: async (data?: RejectPriceSurveyValidationSchema) => {
      const price_survey = {
        ...data,
      }

      return await privateAxios.put(`/client/price_surveys/${priceSurveyId}/${review}`, {
        price_survey,
      })
    },
    onSuccess,
    onError,
  })
}
